import styled from "styled-components";
import { media } from "../../config/helpers/queries/media";

export const StepWrapperStyles = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  margin: auto;
  height: 100%;
  gap: 12px;

  ${media.tablet`
    flex-direction: column;
  gap: 2px;
  `}

  .text {
    display: none;

    ${media.tablet`
      display: flex;
      justify-content: center;
      font-size: 8px;
      margin-top: 5px;
      text-align: center;
      width: 10px;
    `}

    ${media.desktop`
      font-size: ${(props) => (props.stepsLength > 7 ? "11px" : "12px")};
    `}
    &-active {
      display: block;
      width: auto;

      @media (max-width: 425px) {
        & {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, +100%);
          white-space: nowrap;
        }
      }
    }
  }
`;
export const StepBtn = styled.div`
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: ${(props) =>
    props.passedStep ? "2px solid #ff1635" : "1px solid #D0CFCFFF"};
  color: ${(props) => (props.passedStep ? "#ff1635" : "#D0CFCFFF")};
  font-weight: bold;
  ${(props) =>
    props.isActive &&
    `
    background-color: #ff1635;
    border:none;
    color:#fff;
  `}
  width: 40px;
  height: 40px;
  font-size: 16px;
  cursor: pointer;
  position: relative;
  animation: animateShadow 1s ease-out infinite;

  @media (max-width: 1280px) {
    & {
      width: 40px;
      height: 40px;
      font-size: 14px;
    }
  }

  @media (max-width: 1280px) {
    & {
      width: 30px;
      min-width: 30px;
      height: 30px;
      min-width: 30px;
      margin-left: ${(props) => (props.isActive ? "0px" : "0px")};
    }
  }
`;

export const LinesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  align-items: center;

  .text {
    display: ${(props) => (props.line ? "block" : "none")};
    font-size: 11px;
    max-width: 10px;
  }

  @media (max-width: 1280px) {
    .text {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      max-width: 10px;
    }
  }
  @media (max-width: 800px) {
    .text {
      display: none;
    }
  }
`;
export const Line = styled.div`
  display: ${(props) => (props.line ? "block" : "none")};
  color: ${(props) => (props.line ? "blue" : "red")};
  height: 10px;
  border-bottom: ${(props) =>
    props.isActive ? "1px solid #ff1635" : "1px solid #D0CFCFFF"};
  width: 100px;
  @media (max-width: 1280px) {
    & {
      max-width: 50%;
    }
  }
  @media (max-width: 800px) {
    & {
      display: none;
    }
  }
`;
